/**
 * True for any path under the public `/c` business-card root: `/c`, `/c/`,
 * `/c/:token`, and any case variant (`/C/...`). Matched case-insensitively,
 * and independently of what follows, so a bare `/c` (no token yet) or an
 * unexpected-case URL never falls through to the authenticated app shell --
 * only an actual sibling route (`/campaigns`, `/contacts`, `/cats`, ...)
 * fails to match, since those don't have `/` or end-of-string immediately
 * after the `c`. `PublicBusinessCard`'s own `TOKEN_SHAPE` check is what
 * actually requires a valid token before rendering real card data; an
 * invalid/missing token renders its "unavailable" state instead.
 *
 * Used by `main.tsx`'s bootstrap branch (see its "Bootstrap correction"
 * comment) to decide which React root to mount. Kept here as a pure,
 * directly-testable function -- `main.tsx` itself only has side effects at
 * import time and is exercised by the bootstrap isolation test in
 * `src/__tests__/mainBootstrap.test.tsx`.
 */
export function isPublicCardPath(pathname: string): boolean {
  return /^\/c(\/.*)?$/i.test(pathname);
}
